import { render, staticRenderFns } from "./TypeAhead.vue?vue&type=template&id=5c4cc3eb&scoped=true&"
import script from "./TypeAhead.vue?vue&type=script&lang=js&"
export * from "./TypeAhead.vue?vue&type=script&lang=js&"
import style0 from "./TypeAhead.vue?vue&type=style&index=0&id=5c4cc3eb&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4cc3eb",
  null
  
)

export default component.exports